import React from 'react';
import Icon from './AppIcon';
import { useNavigate } from 'react-router-dom';

const InsufficientCreditsModal = ({ isOpen, onClose, creditBreakdown }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    navigate('/landing-page#pricing');
    onClose();
  };

  const handlePurchase = () => {
    navigate('/landing-page#pricing');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-warning/10 rounded-full">
              <Icon name="AlertCircle" size={32} className="text-warning" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-foreground text-center mb-2">
            Insufficient Credits
          </h2>
          <p className="text-muted-foreground text-center mb-6">
            You don't have enough credits to create a new case. Purchase more credits or upgrade your plan to continue.
          </p>

          {/* Current Balance */}
          <div className="bg-muted/30 rounded-lg p-4 mb-6">
            <p className="text-sm text-muted-foreground mb-2">Current Balance</p>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-foreground">Trial Credits</span>
                <span className="text-sm font-medium text-foreground">{creditBreakdown?.trial || 0}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-foreground">Monthly Credits</span>
                <span className="text-sm font-medium text-foreground">{creditBreakdown?.monthly || 0}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-foreground">Paid Credits</span>
                <span className="text-sm font-medium text-foreground">{creditBreakdown?.paid || 0}</span>
              </div>
              <div className="border-t border-border pt-2 flex justify-between items-center">
                <span className="text-sm font-semibold text-foreground">Total</span>
                <span className="text-lg font-bold text-foreground">{creditBreakdown?.total || 0}</span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleUpgrade}
              className="w-full px-4 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-smooth flex items-center justify-center gap-2"
            >
              <Icon name="Zap" size={18} />
              Upgrade to Monthly Plan
            </button>
            <button
              onClick={handlePurchase}
              className="w-full px-4 py-3 bg-secondary text-secondary-foreground rounded-lg font-medium hover:bg-secondary/90 transition-smooth flex items-center justify-center gap-2"
            >
              <Icon name="ShoppingCart" size={18} />
              Purchase One-Time Credits
            </button>
            <button
              onClick={onClose}
              className="w-full px-4 py-3 bg-background border border-border text-foreground rounded-lg font-medium hover:bg-muted transition-smooth"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsufficientCreditsModal;